export default "__VITE_ASSET__CeYg3Jwd__"